// src/pages/public/SinPermisos.jsx
// UX audit ISSUE 5: página explícita para quien intenta acceder a una
// ruta que requiere rol que no tiene. Reemplaza el redirect silencioso
// a /dashboard que era confuso (el usuario clickeaba un link admin y
// quedaba en /dashboard sin saber por qué).
//
// FIX safety net: un cliente con sesión NUNCA debería ver esta página.
// Si llega aquí (por ejemplo state.from contaminado, FIX hecho en
// Login.jsx) lo redirigimos automáticamente al destino correcto por
// rol. Solo mostramos esta página si user es null (sesión expirada).
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../auth/AuthContext';

export default function SinPermisos() {
  const navigate = useNavigate();
  const { user, userData, loading, hasAccess, isAdmin } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (!user) return; // sin sesión: dejar mostrar la página
    if (user && !userData) return; // esperar primer snap del Firestore
    if (isAdmin) return; // admin se quedó por permission específico (ruta no admin/dashboard)
    // Cliente con sesión: nunca debería estar aquí. Auto-redirect.
    if (hasAccess) {
      navigate('/dashboard', { replace: true });
    } else {
      navigate('/paywall', { replace: true });
    }
  }, [user, userData, loading, hasAccess, isAdmin, navigate]);

  const destinoPrincipal = isAdmin
    ? '/admin/dashboard'
    : (hasAccess ? '/dashboard' : '/paywall');
  const labelPrincipal = isAdmin
    ? 'Volver al panel admin'
    : (hasAccess ? 'Volver al dashboard' : 'Ver planes');

  return (
    <div className="mobile-root">
      <Helmet>
        <title>Sin permisos · Edge Elite</title>
      </Helmet>
      <section
        className="screen"
        style={{
          paddingTop: 60,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          paddingBottom: 40,
        }}
      >
        <div
          aria-hidden="true"
          style={{
            width: 88,
            height: 88,
            borderRadius: 999,
            background: 'rgba(234,179,8,.14)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 22,
          }}
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#EAB308"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 26,
            fontWeight: 700,
            letterSpacing: '-0.025em',
            margin: 0,
            marginBottom: 10,
          }}
        >
          Sin permisos
        </h2>
        <p
          style={{
            fontSize: 14,
            color: 'var(--muted)',
            margin: 0,
            marginBottom: 28,
            maxWidth: 340,
            lineHeight: 1.55,
          }}
        >
          Esta sección está reservada para administradores. Si crees que
          deberías tener acceso, contacta al equipo.
          {user?.email && (
            <>
              <br />
              <span style={{ fontSize: 12, color: 'var(--muted-2, var(--muted))' }}>
                Sesión activa: <strong style={{ color: 'var(--ink)' }}>{user.email}</strong>
              </span>
            </>
          )}
        </p>

        <button
          className="btn-primary accent"
          style={{ width: '100%', maxWidth: 320 }}
          onClick={() => navigate(destinoPrincipal, { replace: true })}
        >
          {labelPrincipal}
        </button>

        <button
          onClick={() => navigate('/', { replace: true })}
          style={{
            marginTop: 12,
            width: '100%',
            maxWidth: 320,
            padding: '12px 20px',
            background: 'transparent',
            border: 0,
            color: 'var(--muted)',
            fontSize: 14,
            fontWeight: 500,
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          Volver al inicio
        </button>
      </section>
    </div>
  );
}
